export { default } from './Capsule';



// WEBPACK FOOTER //
// ./app/components/borrowing/fines/Capsule/index.js